import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials } from '../data/mock';
import { Card, CardContent } from './ui/card';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
      }, 6000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    setIsAutoPlaying(false);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-description">
            Real experiences from souls we've guided on their cosmic journey
          </p>
        </div>

        <div className="testimonial-carousel"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          <button className="testimonial-nav prev" onClick={prevTestimonial}>
            <ChevronLeft size={28} />
          </button>

          <Card className="testimonial-card">
            <CardContent className="testimonial-content">
              <div className="quote-mark">"</div>
              <div className="stars">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} fill="#EECE7B" color="#EECE7B" />
                ))}
              </div>
              <p className="testimonial-text">{currentTestimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4 className="author-name">{currentTestimonial.name}</h4>
                  <p className="author-location">{currentTestimonial.location}</p>
                  <p className="author-zodiac">{currentTestimonial.zodiac} • {currentTestimonial.date}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <button className="testimonial-nav next" onClick={nextTestimonial}>
            <ChevronRight size={28} />
          </button>
        </div>

        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                setCurrentIndex(index);
                setIsAutoPlaying(false);
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;